export default __webpack_public_path__ + "static/media/weeknd1.878f9ddb.png";